import { render, staticRenderFns } from "./BusinessHelp.vue?vue&type=template&id=1dcb12e1&"
import script from "./BusinessHelp.vue?vue&type=script&lang=js&"
export * from "./BusinessHelp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports